import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import FieldTableCustomColumnIds from '../../../../constants/FieldTableCustomColumnIds';

const StyledRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

const StyledTH = styled.div`
  display: flex;
  font-size: ${(props) => props.fontSize}px;
  color: ${(props) => props.fontColor};
  font-style: ${(props) => props.fontStyle};
  font-weight: ${(props) => props.fontWeight};
  text-align: ${(props) => props.textAlign};
  text-transform: ${(props) => props.textTransform};
  text-decoration: ${(props) => props.textDecoration};
  border-right: ${(props) => props.border};
  padding: ${(props) => props.padding}px;
  border-bottom: ${(props) => props.border};
  background-color: ${(props) => props.backgroundColor};
  resize: none;
  ${(props) => {
    if (props.width) {
      return `max-width: ${props.width}px; min-width: ${props.width}px;`;
    } else {
      return 'flex: 1;';
    }
  }}
  vertical-align: top;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  svg {
    font-size: 12px;
  }
`;

const StyledTitleWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
`;

const StyledTitle = styled.span`
  display: flex;
  flex: 1;
  display: inline-block;
`;

class TableFieldHeader extends PureComponent {

  static propTypes = {
    id: PropTypes.string,
    disabled: PropTypes.bool,
    editable: PropTypes.bool,
    columns: PropTypes.array,
    columnWidths: PropTypes.object,

    //Action handlers
    onColumnRefs: PropTypes.func,

    //Styles
    fontSize: PropTypes.number,
    fontColor: PropTypes.string,
    fontStyle: PropTypes.string,
    fontWeight: PropTypes.string,
    textAlign: PropTypes.string,
    textTransform: PropTypes.string,
    textDecoration: PropTypes.string,
    borderColor: PropTypes.string,
    borderWidth: PropTypes.number,
    backgroundColor: PropTypes.string,
    padding: PropTypes.number,

  }

  render() {

    const {
      id,
      disabled,
      editable,
      columns,
      columnWidths = {},

      //Action handlers
      onColumnRefs,

      //Field style
      fontSize,
      fontColor,
      fontStyle,
      fontWeight,
      textAlign,
      textTransform,
      textDecoration,
      borderColor,
      borderWidth,
      backgroundColor,
      padding
    } = this.props;

    /**
     * We join width and color to a single border style because chrome displays
     * the border as a two tone color if you use border-color and border-width
     * indvidually.
     */
    const border = `${borderWidth}px solid ${borderColor}`;

    const columnNodes = columns.map((column, columnIndex) => {

      const isUtilityColumn = (column._id === FieldTableCustomColumnIds.rowMenu || column._id === FieldTableCustomColumnIds.rowNumber);

      let columnNode = (<StyledTitle>{column.title}</StyledTitle>);

      if (editable && !disabled && !isUtilityColumn) {
        columnNode = (
          <>
            <StyledTitle>{column.title}</StyledTitle>
          </>
        );
      }

      return (
        <StyledTH
          key={column._id}
          data-testid={`${id}-${column._id}-${columnIndex}-column-th`}
          ref={(e) => {

            if (e) {
              if (!this.colRefs) this.colRefs = [];
              this.colRefs.push({ columnId: column._id, e });
            }

            if (onColumnRefs && this.colRefs.length === columns.length) {
              onColumnRefs(this.colRefs);
            }

          }}
          {...{
            width: column.width || (columnWidths && columnWidths[column._id]),
            fontSize,
            fontColor,
            fontStyle,
            fontWeight,
            textAlign,
            textTransform,
            textDecoration,
            border,
            backgroundColor,
            padding,
          }}
        >
          <StyledTitleWrapper>
            {columnNode}
          </StyledTitleWrapper>
        </StyledTH>
      );

    });

    return (
      <StyledRow
        data-testid={`${id}-table-field-header-row`}
        {...{
          border,
          backgroundColor
        }}
      >
        {columnNodes}
      </StyledRow>
    );

  }

}

export default TableFieldHeader;
